<script setup lang="ts">
import { computed } from "vue";
import type { PropType } from "vue";
import { useI18n } from "vue-i18n";

import type { ModalVariant } from "@/types/stores/modalStore.type.ts";

const { t } = useI18n();

const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  message: {
    type: String,
    default: "",
  },
  validateButton: {
    type: String,
    default: "",
  },
  cancelButton: {
    type: String,
    default: "",
  },
  validateDisabled: {
    type: Boolean,
    default: false,
  },
  validateLoading: {
    type: Boolean,
    default: false,
  },
  cancelDisabled: {
    type: Boolean,
    default: false,
  },
  variant: {
    type: String as PropType<ModalVariant>,
    default: "default",
  },
});

const emits = defineEmits(["closeModal"]);

const validateColor = computed<string | undefined>(() =>
  props.variant === "destructive" ? "error" : undefined,
);
</script>

<template>
  <v-card>
    <p class="text-h6 font-weight-bold mb-3">
      {{ title }}
    </p>
    <p
      v-if="message"
      class="text-body-2 text-medium-emphasis text-pre-line mb-6"
    >
      {{ message }}
    </p>
    <slot />
    <div class="d-flex justify-end flex-wrap ga-4">
      <v-btn
        variant="tonal"
        :disabled="cancelDisabled"
        @click="emits('closeModal', false)"
      >
        {{ cancelButton || t("common.buttons.cancel") }}
      </v-btn>
      <v-btn
        :color="validateColor"
        :disabled="validateDisabled"
        :loading="validateLoading"
        @click="emits('closeModal', true)"
      >
        {{ validateButton || t("common.buttons.validate") }}
      </v-btn>
    </div>
  </v-card>
</template>
